export const initialState ={
  error: null,
  isFetching: false,
  shouldReload: false,
  data: [],
  totalCount: 0,

  detailData:{},

  isListToDetail: false,
}
